/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type KycStatus = 0 | 1;

export const KycStatus = {
    NUMBER_0: 0 as KycStatus,
    NUMBER_1: 1 as KycStatus
};

